import { render, staticRenderFns } from "./OrderLogsDetail.vue?vue&type=template&id=4ac3a288&"
import script from "./OrderLogsDetail.vue?vue&type=script&lang=js&"
export * from "./OrderLogsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports